import { useEffect } from 'react';

import { ellipsisApi } from '../redux/ellipsisApi';
import { useAppDispatch, useAuth } from '../redux/hooks';
import authSlice, { hasSessionCookie } from '../redux/reducers/authSlice';
import { clearSessionRestoringMark } from '../utils/sessionCookie';

// Restores a signed-in user from the jwtToken cookie, and fetches currency
// rates - both client-only (the cookie isn't readable server-side, and
// there's no reason to block the SSR response on a rates fetch). Runs once
// per page mount, so every top-level page needs it: App.tsx for the SPA, and
// createBookablePage's shared SSR shell (BookablePage.tsx) for the SSR
// pages, which otherwise never resolve authSlice's `sessionRestoring` flag
// (set from the cookie at store-creation time - see authSlice.ts) because
// nothing ever dispatches the getUsersMe that would clear it.
export function useSessionBootstrap() {
  const dispatch = useAppDispatch();
  const { user } = useAuth();

  // Rates don't depend on the user, so fetch them once per mount rather
  // than again whenever `user` changes (e.g. when the session is restored).
  useEffect(() => {
    dispatch(ellipsisApi.endpoints.getExchangeRates.initiate());
  }, [dispatch]);

  useEffect(() => {
    if (user || !hasSessionCookie()) {
      clearSessionRestoringMark();
      return;
    }
    dispatch(authSlice.actions.startSessionRestore());
    dispatch(ellipsisApi.endpoints.getUsersMe.initiate()).then((result) => {
      if (result.isError) clearSessionRestoringMark();
    });
  }, [dispatch, user]);
}
